export const GOOGLE_BUSINESS = "googlebusiness";
export const APIDECK = "apideck";